var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg45(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4466_96736)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4466_96736",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0.5H0V24.5H24V0.5Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4466_96736)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4466_96736",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.500002H24V24.5H0V0.500002Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4466_96736)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.308 16.3581C11.1261 16.5823 7.91773 13.3739 8.14193 9.19201C8.36613 5.0101 11.938 1.43823 16.1199 1.21402C20.3018 0.989821 23.5102 4.19818 23.286 8.38009C23.0618 12.562 19.4899 16.1339 15.308 16.3581Z",
    stroke: "black",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.14155 9.19239L7.90136 12.7353C7.8212 13.9173 7.31547 15.0301 6.47786 15.8677L0.994141 21.3514L3.14861 23.5059L8.63228 18.0222L8.63233 18.0221C9.46994 17.1845 10.5827 16.6788 11.7647 16.5987L15.3076 16.3585",
    stroke: "black",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.42773 11.7627L18.6218 1.5686",
    stroke: "black",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0723 14.4277L21.286 3.21397",
    stroke: "black",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7363 16.0723L22.9304 5.87817",
    stroke: "black",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1328 1.96406L22.5359 11.3672",
    stroke: "black",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5879 3.72908L20.7709 13.9121",
    stroke: "black",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.82227 6.27363L18.2254 15.6768",
    stroke: "black",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5128 21.3139C20.5128 22.6852 19.4011 23.7969 18.0298 23.7969C16.6585 23.7969 15.5469 22.6852 15.5469 21.3139C15.5469 19.9426 16.6585 18.8309 18.0298 18.8309C19.4011 18.8309 20.5128 19.9426 20.5128 21.3139Z",
    stroke: "black",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.57608 18.9658L5.5332 14.9229",
    stroke: "black",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4466_96736"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg45);
export default __webpack_public_path__ + "static/media/45.1af1b2457a4c99c659f288153cd1eda0.svg";
export { ForwardRef as ReactComponent };